import * as $ from "jquery";

export class Testimonials {
    quoteidlist: Array<number>;
    currentQuote: number;

    constructor(quoteidlist: Array<number>) {
        const self = this;
        self.quoteidlist = quoteidlist;
        self.currentQuote = 0;

        window.onpopstate = function (event) {
            const currentQuote = event.state.quote;
            self.getQuote(false, currentQuote);
        };

        // Load initial content
        this.getStudent();

        // Previous quote
        $("#prev").on("click", function () {
            self.currentQuote = self.currentQuote - 1;

            if (self.currentQuote < 0) {
                self.currentQuote = quoteidlist.length - 1;
            }
            self.getQuote(true, self.currentQuote);
        });
        // Next quote
        $("#next").on("click", function () {
            self.currentQuote = self.currentQuote + 1;

            if (self.currentQuote >= quoteidlist.length) {
                self.currentQuote = 0;
            }
            self.getQuote(true, self.currentQuote);
        });
    }

    // Update quote name
    getStudent() {
        const $name = $("#student-name");
        if ($name) {
            const dataname = <string> $name.data("name");
            if (dataname) {
                $name.text(dataname);
            }
        }
    }

    // Load new quote
    getQuote(shouldUpdate: boolean, currentQuote: number) {
        const self = this;
        $(".testimonial-container .mural .content .target").load(
            "/Testimonial/Lsatquote/" + self.quoteidlist[currentQuote],
            function () {
                self.getStudent();

                if (shouldUpdate) {
                    self.updateHistory(currentQuote);
                }
            },
        );
    }

    // Create a quote history
    updateHistory(currentQuote: number) {
        const self = this;
        const url = "/Lsat-Testimonial/" + self.quoteidlist[currentQuote];
        const fullurl = `${location.protocol}//${location.host}${url}`;
        window.history.pushState(
            { "quote": currentQuote },
            "LSAT Success Stories - " + $("#student-school").text(),
            url,
        );

        // update canonical tag
        const $canonical = $('link[rel="canonical"]');
        if ($canonical.length !== 0) {
            $canonical.attr("href", fullurl);
        }
    }
}
